/**
 * WRMS Form Header — Digi Sahyadri Branding
 * Appears at the top of all 4 request forms
 */

import React from 'react';

const WRMSFormHeader = ({ formTitle, formSubtitle, requestId }) => {
  return (
    <div className="wrms-form-header">
      <div className="wrms-brand-logo">
        <div className="wrms-brand-icon">DS</div>
        <div className="wrms-brand-text">
          <h3>Digi Sahyadri</h3>
          <p>DIGITAL MARKETING AGENCY</p>
        </div>
      </div>

      <div className="wrms-form-title">
        <h4>{formTitle}</h4>
        <p>{formSubtitle || 'Leave & Request System'}</p>
        {requestId && (
          <div className="wrms-request-id">{requestId}</div>
        )}
      </div>
    </div>
  );
};

export default WRMSFormHeader;
